const detectGoogle = () => {
  var userAgent = Window && navigator.userAgent
  const location = Window && window.location

  if (
    /bot|crawl|spider|Mediapartners-Google|AdsBot-Google-Mobile|AdsBot-Google-Mobile|AdsBot-Google|robots.txt/i.test(
      userAgent
    )
  ) {
    return true
  }

  if (location.search && location.search.includes('GA_network')) {
    return true
  }

  return false
}

export default detectGoogle
